import { GameTypes } from '../../../../../types/GlobalTypes';

export function shouldShowAdditionalActions(gameType: string) {
  return gameType === GameTypes.BUSINESS || gameType === GameTypes.INDIVIDUAL_PAID;
}
